export const environment = {
  production: true,
  //   apiUrl: 'https://api.pronto-resto.com/',
  apiUrl: 'https://api.pronto-resto.com/',
  imageUrl: 'https://pronto-restro.s3.eu-central-1.amazonaws.com/',
};
